import { ReactNode } from 'react';

import NotFound from '@/pages/NotFound';
import { useSession } from '@/providers/SessionProvider/SessionProvider';

interface IWithStaffAccess {
  children?: ReactNode;
}
const WithStaffAccess = ({ children }: IWithStaffAccess) => {
  const { currentUser } = useSession();
  if (currentUser?.isStaff) {
    return children;
  } else {
    return <NotFound />;
  }
};
export default WithStaffAccess;
